__turbopack_context__.v({
  "checkout-loader": "Layout-module-scss-module__kf6Wqa__checkout-loader",
  "checkout-loader-text": "Layout-module-scss-module__kf6Wqa__checkout-loader-text",
  "contents": "Layout-module-scss-module__kf6Wqa__contents",
  "focus-mode-body": "Layout-module-scss-module__kf6Wqa__focus-mode-body",
  "focus-mode-contents": "Layout-module-scss-module__kf6Wqa__focus-mode-contents",
  "focus-mode-edited-contents": "Layout-module-scss-module__kf6Wqa__focus-mode-edited-contents",
  "focus-mode-editing-bar": "Layout-module-scss-module__kf6Wqa__focus-mode-editing-bar",
  "focus-notifications-section": "Layout-module-scss-module__kf6Wqa__focus-notifications-section",
  "layout": "Layout-module-scss-module__kf6Wqa__layout",
  "main-content": "Layout-module-scss-module__kf6Wqa__main-content",
  "mobile-overlay": "Layout-module-scss-module__kf6Wqa__mobile-overlay",
  "notifications-section": "Layout-module-scss-module__kf6Wqa__notifications-section",
});
